/*eslint-disable*/
import React from "react";
import {
  Flex,
  Link,
  List,
  ListItem,
  Text,
  Button,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";

export default function Footer() {
  const textColor = useColorModeValue("gray.400", "white");
  const { toggleColorMode } = useColorMode();
  return (
    <Flex
      as="footer"
      bg={useColorModeValue("gray.100", "gray.800")}
      borderTop="1px solid"
      borderColor={useColorModeValue("gray.200", "gray.700")}
      mt="auto"
      py="20px"
      px={{ base: "30px", md: "50px" }}
      justify="space-between"   // مهم: فاصله بین دو متن
      align="center"
      width="100%"             // مهم: تا flex کل عرض را بگیرد
    >
      {/* نیمه اول */}
      <Text fontSize="xs" color={textColor}>
        {/* &copy; {new Date().getFullYear()} */}
        © {new Date().getFullYear()} RHI Journals, All rights reserved.
      </Text>

      {/* نیمه دوم */}
      <Text fontSize="xs" fontWeight="500" color={textColor}>
        Designed and Developed by <a href="https://bioinformatic.rhc.ac.ir/" target="_blank" style={{ color: '#f80c3e', fontWeight: 'bolder' }}>Bioinformatic Department</a>, Rajaie Institute
      </Text>
    </Flex>
  );
}

